// AI: This new component encapsulates the light entrepreneur client editing form and logic in a dialog.
// AI: This new component encapsulates the light entrepreneur client editing form and logic in a dialog.
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Client } from 'src/app/api/models';
import { ClientsService } from 'src/app/api/services';
import { CountriesMap, CountriesMapCache } from 'src/app/model/model-map-cache';
import { Money } from 'src/app/model/money';
import { canonicalizeBusinessIdControl, clientBusinessIdValidator } from 'src/app/validators/business-id/angular-adapter';

@Component({
  selector: 'app-light-entrepreneur-client-edit-dialog',
  templateUrl: './light-entrepreneur-client-edit-dialog.component.html',
  styleUrls: ['./light-entrepreneur-client-edit-dialog.component.scss']
})
export class LightEntrepreneurClientEditDialogComponent implements OnInit {

  clientForm: UntypedFormGroup;
  client: Client;
  countries$: Observable<CountriesMap>;

  constructor(
    public dialogRef: MatDialogRef<LightEntrepreneurClientEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { client: Client },
    private builder: UntypedFormBuilder,
    private clientsService: ClientsService,
    private countriesMapCache: CountriesMapCache,
  ) {
    this.client = { ...data.client }; // Create a clone to avoid modifying the original object
  }

  ngOnInit(): void {
    this.countries$ = this.countriesMapCache.map$;
    this.initializeForm();
    this.patchForm();
  }

  initializeForm(): void {
    this.clientForm = this.builder.group({
      name: [{ value: '', disabled: true }, Validators.required],
      personal_id: [{ value: null, disabled: true }, [Validators.required]],
      invoicing_service_company_business_id: [{ value: null, disabled: true }, [Validators.required, clientBusinessIdValidator()]],
      country: [{ value: '', disabled: true }, Validators.required],
      has_credit_limit: [false],
      credit_limit: this.builder.group({
        limit: this.builder.group({
          amount: [0, [Validators.min(0)]],
          currency: ['EUR'],
        }),
      }),
    });
  }

  patchForm(): void {
    this.clientForm.patchValue({
      ...this.client,
      has_credit_limit: !!this.client.credit_limit,
    });
  }

  save(): void {
    if (this.clientForm.invalid) {
      return;
    }

    // invoicing_service_company_business_id is disabled (a stored value), so the
    // helper skips it and getRawValue() submits it byte-identical (design D10).
    canonicalizeBusinessIdControl(this.clientForm.get('invoicing_service_company_business_id'));

    const formValue = this.clientForm.getRawValue();
    Object.assign(this.client, formValue);

    if (this.client.credit_limit) {
      this.client.credit_limit.limit = new Money(this.client.credit_limit.limit);
    }

    if (!formValue.has_credit_limit) {
      this.client.credit_limit = null;
    }

    this.clientsService.updateClient({ id: this.client.id, body: this.client })
      .pipe(take(1))
      .subscribe(() => {
        this.dialogRef.close(true);
      });
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
